export const ALL_SERVICES = ['store-status'];
